/**
 * App
 */
export * from './app.module';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/index.ts